export function isEmployeeAccessRole(
  selectedRole: string | null | undefined
): boolean {
  const role = (selectedRole ?? "Employee").toLowerCase();
  return role === "employee" || role === "process compliance officer";
}
